export const LIST = "WHITELIST_IP_LIST";
export const STORE = "WHITELIST_IP_STORE";
export const DETAILS = "WHITELIST_IP_DETAILS";
export const UPDATE = "WHITELIST_IP_UPDATE";
export const DELETE = "WHITELIST_IP_DELETE";
